import { Component, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppPopupHostComponent } from './components/app-popup-host/app-popup-host.component';
import { DomainDetectionService } from './services/domain-detection.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppPopupHostComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('frontend');

  constructor(private domainDetectionService: DomainDetectionService) {}

  ngOnInit(): void {
    // Detect custom domain and route accordingly on app initialization
    this.domainDetectionService.detectAndRouteCustomDomain().catch(error => {
    });
  }
}
